/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/
import { useQuery, gql } from '@apollo/client';
import { useLocation } from 'react-router-dom';

export const useRefinitiveToken = (skipCondition) => {
    const location = useLocation();
    const skipApi = location?.pathname?.includes('sitemaintenance');
    
    const REFINITIV_GQL = gql`
    query getRefinitivToken {
      refinitivSamlToken {
        token
      }
    }
  `;

 
    const { loading, data, error } = useQuery(REFINITIV_GQL, {
      fetchPolicy: 'network-only',
      skip: skipApi || skipCondition
    });

   return {loading, data, error}

}